import React, { Component } from 'react';
import NewAccountFormService from '../../services/NewAccountForm.service';
import SelectComponent from '../../../../views/components/Select.component';
import NewAccountFormEntry from '../../models/NewAccountFormEntry';

import FormError from '../../../../models/FormError';
import InputField from '../../../../views/components/InputField.Component';
import TextArea from '../../../../views/components/TextArea.Component';
import FileInput from '../../../../views/components/FileInput.Component';
import ErrorFieldMessage from '../../../../views/components/FieldErrorMessage.Component';
import NewAccountFormConfiguration from '../../models/NewAccountFormConfiguration';
import FormValidationService from '../../services/FormValidationService';
import PostalCodeInputField from '../../../../views/components/PostalCodeInputField.Component';

type NewAccountFormPageProps = {
    formID: string,
}

type NewAccountFormPageState = {
    configuration: NewAccountFormConfiguration,
    newCustomer: boolean,
    values: NewAccountFormEntry,
    errors: FormError[],
    translatedErrorMessages: any
    submitting: boolean,
}

export default class NewAccountFormPage extends Component<NewAccountFormPageProps, NewAccountFormPageState> {

    public NewAccountFormValidator: FormValidationService = new FormValidationService();

    constructor(props: NewAccountFormPageProps) {
        super(props);

        this.state = {
            configuration: new NewAccountFormConfiguration(),
            newCustomer: true,
            values: new NewAccountFormEntry(),
            errors: [],
            translatedErrorMessages: {},
            submitting: false,
        };
    }

    public async componentDidMount() {
        const service: NewAccountFormService = new NewAccountFormService();

        const configuration: NewAccountFormConfiguration = await service.getNewAccountFormConfiguration(this.props.formID);
        const errorMessages: any = await service.getErrorMessageTranslations();

        this.NewAccountFormValidator.translatedErrorMessages = errorMessages;

        this.setState({
            configuration: configuration,
            translatedErrorMessages: errorMessages
        })
    }

    private async setValue(propertyName: string, value: string): Promise<FormError[]> {
        let errors: FormError[] = [];
        const values: any = this.state.values;

        value = value.trim();

        if (values.hasOwnProperty(propertyName)) {
            values[propertyName] = value;
            errors = await this.validateProperty(values, propertyName);
        }
        else {
            console.error("Error: property " + propertyName + " was not found on the values and could not be filled in correctly");
        }

        this.setState({
            values: values
        });

        return errors;
    }

    private setConsent(value: boolean): void {
        let errors: FormError[] = [];
        const values: NewAccountFormEntry = this.state.values;

        values.consent = value;

        this.setState({
            values: values
        });
    }

    public async setFiles(files: File[]) {
        const values = this.state.values;
        values.files = files;

        let errors: FormError[] = await this.NewAccountFormValidator.validate(values, this.state.newCustomer);

        this.setState({
            values: values,
            errors: errors,
        });
    }

    public async sendForm() {
        this.setState({ submitting: true })
        let errors: FormError[] = await this.NewAccountFormValidator.validate(this.state.values, this.state.newCustomer);

        this.setState({
            errors: errors
        });

        if (errors.length == 0) {
            await new NewAccountFormService().sendNewAccountForm(this.state.values);
            window.location.href = this.state.configuration.redirectPageURL;
        } else {
            this.setState({ submitting: false })
        }
    }

    public async validateProperty(values: NewAccountFormEntry, propertyName: string): Promise<FormError[]> {
        return this.NewAccountFormValidator.validateProperty(values, this.state.newCustomer, propertyName);
    }

    public render() {
        return (
            <div className="mt-5 mb-5">
                <h4>{this.state.configuration.title}</h4>
                <div className="p">
                    {this.state.configuration.title}
                </div>
                <hr className="border-brown-25-alpha" />
                <form>
                    <div className="my-5">
                        <InputField id="personal-info-lastname" autocomplete="family-name" name="lastname" label={this.state.configuration.lastnameLabel} placeholder={this.state.configuration.lastnamePlaceholder} onChange={this.setValue.bind(this)} errors={this.state.errors}></InputField>
                        <InputField id="personal-info-firstname" autocomplete="given-name" name="firstname" label={this.state.configuration.firstnameLabel} placeholder={this.state.configuration.firstnamePlaceholder} onChange={this.setValue.bind(this)} errors={this.state.errors}></InputField>
                        <InputField id="personal-info-email" autocomplete="email" name="email" label={this.state.configuration.emailLabel} placeholder={this.state.configuration.emailPlaceholder} onChange={this.setValue.bind(this)} errors={this.state.errors}></InputField>
                        <InputField id="personal-info-fileNumber" name="fileNumber" label={this.state.configuration.fileLabel} placeholder={this.state.configuration.filePlaceholder} onChange={this.setValue.bind(this)} errors={this.state.errors}></InputField>
                    </div>
                    <div className="my-5">

                        <FileInput
                            id="personal-info-files"
                            name="files"
                            acceptFormats={'image/jpeg, image/png, application/pdf'}
                            acceptFormatsLabel={'jpg, png, pdf'}
                            label={this.state.configuration.identitycardLabel}
                            maxSize={this.state.configuration.fileMaxSize}
                            filesToLargeValidationMessage={this.state.configuration.fileToLargeValidationMessage}
                            addFilesLabel={this.state.configuration.identityCardAddFileLabel}
                            dragFilesLabel={this.state.configuration.identityCardDragFileLabel}
                            onChange={this.setFiles.bind(this)}
                            errors={this.state.errors}
                            fileUploadAllowedFormatsLabel={this.state.configuration.fileUploadAllowedFormatsLabel}>
                        </FileInput>
                    </div>
                    <div className="my-5">
                        <div className="d-flex bg-brown-10-alpha p-2">
                            <div className="custom-control custom-checkbox my-2">
                                <input className="custom-control-input"
                                    type="checkbox" id="consent" name="consent" onChange={(event: React.ChangeEvent<HTMLInputElement>) => { this.setConsent(event.target.checked) }}
                                />
                                <label className="custom-control-label font-weight-normal" htmlFor="consent"><span dangerouslySetInnerHTML={{ __html: this.state.configuration.consentLabel }}></span> <a href={this.state.configuration.privacyPageURL} target="_blank">{this.state.configuration.privacyPageLabel}</a>.</label>
                            </div>
                        </div>
                        <ErrorFieldMessage name="consent" errors={this.state.errors}></ErrorFieldMessage>
                    </div>
                    <button className="btn btn-primary form-control" type="button" onClick={() => { this.sendForm(); }} disabled={this.state.submitting}>{this.state.configuration.sendButton}</button>
                </form>
            </div >
        );
    }
}